import { fetchSsrContent } from "@/dataLayer/cms";
import {
  BUNDLE_CODE,
  CONVENIENCE_FEE_CODE,
  DEFAULT_CURRENCY_CODE,
  EXTRA_SEAT_CODE,
  FEE_CODES,
  LOUNGE_SSRCODE,
  PASSENGER_TYPE,
  SEAT_PLUS_MEAL_FEE_CODE
} from "../constants/variables";
import { getAddOnDetails } from "../dataLayer/addOnDetails";
import { Booking } from "../global";
import { deepCopy } from "../utils/jsonUtils";

export function calculateFareForJourney(journeyList, brandFareIndex = 0, passenger = null) {
  try {
    const priceObj = [];
    let totalPrice = 0;
    let discountPrice = 0;
    let subtractAmount = 0;
    for (let index = 0; index < journeyList.length; index += 1) {
      if (journeyList[index]?.totalFares[brandFareIndex[index]]?.fareTotal) {
        totalPrice += parseFloat(journeyList[index]?.totalFares[brandFareIndex[index]].fareTotal);
        discountPrice += parseFloat(journeyList[index]?.totalFares[brandFareIndex[index]].discountedTotal);
        if (!isNaN(journeyList[index]?.subtractAmount?.overall)) {
          subtractAmount += journeyList[index]?.subtractAmount?.overall;
        }
      }

      // if(passenger){
      //   subtractAmount = subtractAmount * (passenger.adult + passenger.child + passenger.seniorcitizen)
      // }
    }

    return {
      totalPrice: totalPrice - subtractAmount,
      discountPrice: discountPrice - subtractAmount
    };
  } catch (error) {
    console.warn("error in Calculate fare for journey", error);
  }
}

export function passengerCount(passenger, key, hasSpecialFare) {
  if (passenger != null) {
    if (
      (key === PASSENGER_TYPE.STUDENT || key === PASSENGER_TYPE.MEDICAL || key === PASSENGER_TYPE.ARMED_FORCE) &&
      passenger.adult > 0
    ) {
      return passenger.adult;
    }
    if (key === PASSENGER_TYPE.ADULT && !hasSpecialFare) {
      return passenger.adult;
    }
    if (key === PASSENGER_TYPE.SENIOR_CITIZEN && passenger.seniorcitizen > 0) {
      return passenger.seniorcitizen;
    }
    if (key === PASSENGER_TYPE.EXTRA_SEAT && passenger.extraSeat > 0) {
      return passenger.extraSeat;
    }    
    if (key === PASSENGER_TYPE.CHILD && passenger.child > 0) {
      return passenger.child;
    }
  }
}

/*
the below function will check the all the ssr avalibe user has added in there booking,
it will return a array, with amount and description
*/
export async function getAdhosPrice(userAdhosList, getPenalitySsrOnly = false, bookingInRedux = null, story = null) {
  try {
    if (typeof userAdhosList !== "undefined") {
      let adhonsList = [];
      if (story == null) {
        const response = await getAddOnDetails();
        if (response) {
          adhonsList = response?.story?.content?.ssr;
        }
      } else {
        adhonsList = story?.content?.ssr;
      }

      let cms = await fetchSsrContent();
      const feesList = cms?.data?.story?.content?.feeSsrs;

      const listOfAdhos = {};
      for (let userInd = 0; userInd < userAdhosList.length; userInd += 1) {
        const userAdhoL1 = userAdhosList[userInd];
        let isSeatSelection = false;
        const userFeeL2 = userAdhoL1?.fees;
        if (userFeeL2) {
          for (let feeInd = 0; feeInd < userFeeL2.length; feeInd += 1) {
            const feeData = deepCopy(userFeeL2[feeInd]);
            let temSsr = feeData.ssrCode;

            if (temSsr == null) {
              temSsr = feeData.code;
              isSeatSelection = true;
            }

            if (temSsr === EXTRA_SEAT_CODE) {
              continue;
            }

            if (getPenalitySsrOnly !== (feeData.type === "PenaltyFee")) {
              continue;
            }

            let finalAmount = userFeeL2[feeInd].serviceCharges[0]?.amount; // total price of adhos;
            const segmentKey = userFeeL2[feeInd].serviceCharges[0]?.detail;
            for (let tempInd = 1; tempInd < userFeeL2[feeInd].serviceCharges.length; tempInd += 1) {
              const tempAddonsPrice = userFeeL2[feeInd].serviceCharges[tempInd];
              if (tempAddonsPrice?.type && tempAddonsPrice?.type !== "IncludedTax") {
                finalAmount += tempAddonsPrice?.amount ? tempAddonsPrice?.amount : 0;
              }
            }

            if (typeof listOfAdhos[temSsr] !== "undefined") {
              if(!feeData?.override){
                listOfAdhos[temSsr].count = listOfAdhos[temSsr].count + 1;
                listOfAdhos[temSsr].totalAmount += finalAmount; // total price of adhos
              }
            } else {
              listOfAdhos[temSsr] = deepCopy(feeData); // helper functin for decopyg
              if(!feeData?.override){
                listOfAdhos[temSsr].count = 1;
                listOfAdhos[temSsr].totalAmount = finalAmount; // total price of adhos
              }else{
                listOfAdhos[temSsr].count = 0;
              }
              listOfAdhos[temSsr].amount = finalAmount; // amount included tax
              if (!listOfAdhos[temSsr].totalAmount) {
                listOfAdhos[temSsr].totalAmount = 0;
              }
             
              if (adhonsList) {
                const tempAdhoData = adhonsList.find((ssr) => ssr.ssrCode === temSsr) ?? feesList?.find((ssr) => ssr.ssrCode === temSsr);
                listOfAdhos[temSsr].details = tempAdhoData;
              }
            }
            if (temSsr === LOUNGE_SSRCODE) {
              const flightRefNumber = feeData?.flightReference.split(" ");
              if (flightRefNumber[2]) {
                const originDestinationKey = flightRefNumber[2].replace(/.{3}/g, "$&-").slice(0, -1);
                listOfAdhos[temSsr][originDestinationKey] = deepCopy(feeData);
                listOfAdhos[temSsr][originDestinationKey]["amount"] =
                  listOfAdhos[temSsr][originDestinationKey]?.serviceCharges[0]?.amount;
              }
            }
            if (!listOfAdhos[temSsr][segmentKey]) {
              listOfAdhos[temSsr][segmentKey] = { amount: 0 };
            }
            
            if(!feeData?.override){
              listOfAdhos[temSsr][segmentKey].amount += finalAmount;
            }

            if (isSeatSelection) {
              if (!listOfAdhos[temSsr].journeyLevelSum) {
                listOfAdhos[temSsr].journeyLevelSum = new Object();
              }
              if (!listOfAdhos[temSsr].journeyLevelSum[userInd]) {
                listOfAdhos[temSsr].journeyLevelSum[userInd] = new Object();
                listOfAdhos[temSsr].journeyLevelSum[userInd].totalAmount = 0;
              }
              listOfAdhos[temSsr].journeyLevelSum[userInd].totalAmount += userFeeL2[feeInd].serviceCharges[0]?.amount;
            }
          }
        }
      }
      // check for fee or hold data ;
      if (bookingInRedux) {
        let totalPaxCount = 1;
        if (bookingInRedux?.currentBookingInState && bookingInRedux?.currentBookingInState?.passengers) {
          totalPaxCount = bookingInRedux?.currentBookingInState?.passengers.length;
        }
        const getAllHoldSSRCode = FEE_CODES;
        for (let holdSsrInd = 0; holdSsrInd < getAllHoldSSRCode.length; holdSsrInd++) {
          const ssrCodes = getAllHoldSSRCode[holdSsrInd];
          if (
            bookingInRedux?.runningAddhons?.[ssrCodes] &&
            bookingInRedux?.runningAddhons?.[ssrCodes]?.isActive == true
          ) {
            listOfAdhos[ssrCodes] = {};
            if (adhonsList) {
              const tempAdhoData = adhonsList.filter((ssr) => ssr.ssrCode === ssrCodes) ?? feesList?.filter((ssr) => ssr.ssrCode === ssrCodes);
              listOfAdhos[ssrCodes].details = tempAdhoData[0];
            }

            listOfAdhos[ssrCodes].totalAmount = bookingInRedux.addhosFare[ssrCodes];
            listOfAdhos[ssrCodes].count = totalPaxCount;
            listOfAdhos[ssrCodes].ssrCode = ssrCodes;
            listOfAdhos[ssrCodes].code = ssrCodes;
          }
        }
        const seatMealRunningAdon = getSeatMealRunningAddon(bookingInRedux);
        if (seatMealRunningAdon) {
          const ssrCode = seatMealRunningAdon.ssrCode;
          if (!listOfAdhos[ssrCode]) {
            listOfAdhos[ssrCode] = {};
            const tempAdhoData = feesList?.filter((ssr) => ssr.ssrCode === ssrCode);
            listOfAdhos[ssrCode].details = tempAdhoData[0];
          }
          listOfAdhos[ssrCode].totalAmount = seatMealRunningAdon.totalAmount + (listOfAdhos[ssrCode].totalAmount || 0);
          listOfAdhos[ssrCode].count = seatMealRunningAdon.count + (listOfAdhos[ssrCode].count || 0);
          listOfAdhos[ssrCode].ssrCode = ssrCode;
          listOfAdhos[ssrCode].code = ssrCode;
        }
      }
      return listOfAdhos;
    }
    return {};
  } catch (error) {
    console.warn(error);
  }
  return [];
}

export function getSeatMealRunningAddon(bookingInRedux: any): any {
  const sellableSsrByJourney = bookingInRedux?.runningAddhons[BUNDLE_CODE.SEAT_PLUS_MEAL]?.sellableSsrByJourney;
  let count = 0;
  let totalAmount = 0;
  if (!sellableSsrByJourney) {
    return null;
  }

  const journeyKeys = Object.keys(sellableSsrByJourney);
  for (let ind = 0; ind < journeyKeys.length; ind++) {
    const journeyKey = journeyKeys[ind];
    if (sellableSsrByJourney[journeyKey]?.bundleselled) {
      continue;
    }
    const paxCount = sellableSsrByJourney[journeyKey]?.passengerCount || 0;
    const price = sellableSsrByJourney[journeyKey]?.price || 0;
    totalAmount += (paxCount * price);
    count += paxCount;
  }
  if (count <= 0) {
    return null;
  }
  return {
    totalAmount,
    count,
    ssrCode: SEAT_PLUS_MEAL_FEE_CODE
  };
}

/*
the below function will check the all the ssr avalibe user has added in there booking,
it will return a array, with amount and description
*/
export async function getAdhosPriceWithJouney(userAdhosList) {
  try {
    if (typeof userAdhosList !== "undefined") {
      let adhonsList = [];
      const response = await getAddOnDetails();
      if (response) {
        adhonsList = response?.story?.content?.ssr;
      }
      const adhosJourneyArray = [];
      const listOfAdhos = {};
      for (let userInd = 0; userInd < userAdhosList.length; userInd += 1) {
        const userAdhoL1 = userAdhosList[userInd];
        const currentJourneyAdhs = {};
        const userFeeL2 = userAdhoL1?.value?.fees;
        // check each ssr and get there deails;
        for (let feeInd = 0; feeInd < userFeeL2.length; feeInd += 1) {
          const feeData = userFeeL2[feeInd];
          if (typeof listOfAdhos[feeData.code] !== "undefined") {
            listOfAdhos[feeData.code].count = listOfAdhos[feeData.code].count + 1;
            if (typeof currentJourneyAdhs[feeData.code] === "undefined") {
              currentJourneyAdhs[feeData.code] = [];
            }
            currentJourneyAdhs[feeData.code].count = listOfAdhos[feeData.code].count;
          } else {
            listOfAdhos[feeData.code] = deepCopy(feeData);
            listOfAdhos[feeData.code].count = 1;
            listOfAdhos[feeData.code].amount = listOfAdhos[feeData.code].serviceCharges[0]?.amount; // amount included tax
            const tempAdhoData = adhonsList.filter((ssr) => ssr.ssrCode == feeData.ssrCode);
            listOfAdhos[feeData.code].details = tempAdhoData[0];

            currentJourneyAdhs[feeData.code] = deepCopy(feeData);
            currentJourneyAdhs[feeData.code].count = 1;
            currentJourneyAdhs[feeData.code].amount = currentJourneyAdhs[feeData.code].serviceCharges[0]?.amount; // amount included tax
            currentJourneyAdhs[feeData.code].details = tempAdhoData[0];
          }
        }
        adhosJourneyArray.push(currentJourneyAdhs);
      }
      return adhosJourneyArray;
    }
    return {};
  } catch (error) {
    console.warn(error);
  }
  return [];
}
export function getInfantfares(passengers, journeyCount, selectedCurrency) {
  let respose = {
    amount: 0,
    count: 0,
    currencyCode: selectedCurrency,
    type: "FarePrice",
    status: false
  };
  for (let ind = 0; ind <= passengers?.length; ind++) {
    if (passengers[ind]?.infant) {
      const amount = passengers[ind]?.infant?.fees?.[0]?.serviceCharges?.[0]?.amount;
      if (!isNaN(amount)) {
        if (ind !== 0) {
          respose = {
            amount: respose?.amount,
            count: respose?.count + 1,
            currencyCode: selectedCurrency,
            type: "FarePrice",
            status: true
          };
        } else {
          respose = {
            amount: amount * journeyCount,
            count: 1,
            currencyCode: selectedCurrency,
            type: "FarePrice",
            status: true
          };
        }
      }
    }
  }
  return respose;
}

export function taxSkipCondition(activeStep, taxData) {
  // activeStep < 2 && (individualFare.code != "WFE" || individualFare.type != "IncludedTax" )
  const returnFlag = true;
  if (activeStep > 2) {
    return returnFlag;
  }

  if (taxData.code !== "WFE" && taxData.type !== "IncludedTax") {
    return returnFlag;
  }
  return false;
}
/*
the below function will be return the complementary meal for the view summary popup
*/
export async function getComplementryMeals(passengerSegment, story = null) {
  try {
    const response = {
      status: true,
      data: {}
    };
    const ssrData = {};
    let adhonsList = [];
    if (story == null) {
      const response = await getAddOnDetails();
      if (response) {
        adhonsList = response?.story?.content?.ssr;
      }
    } else {
      adhonsList = story?.content?.ssr;
    }

    if (passengerSegment) {
      for (let paxSegInd = 0; paxSegInd < passengerSegment.length; paxSegInd += 1) {
        const segmentInfo = passengerSegment[paxSegInd]?.segments;
        for (let segmentInd = 0; segmentInd < segmentInfo.length; segmentInd += 1) {
          const paxInfo = segmentInfo[segmentInd]?.passengerSegment;
          for (let paxInd = 0; paxInd < paxInfo.length; paxInd += 1) {
            const paxSsrs = paxInfo[paxInd]?.value?.ssrs;
            for (let ssrInd = 0; ssrInd < paxSsrs.length; ssrInd += 1) {
              const ssrInfo = paxSsrs[ssrInd];
              if (ssrInfo.inBundle && ssrInfo.ssrCode !== "PLUS") {
                if (ssrData[ssrInfo.ssrCode]) {
                  ssrData[ssrInfo.ssrCode].count = ssrData[ssrInfo.ssrCode]?.count + 1;
                } else {
                  ssrData[ssrInfo.ssrCode] = deepCopy(ssrInfo);
                }

                const tempAdhoData = adhonsList.filter((ssr) => ssr.ssrCode === ssrInfo.ssrCode);
                ssrData[ssrInfo.ssrCode].details = tempAdhoData[0];
              }
            }
          }
        }
      }
    }
    response.data = ssrData;
    return response;
  } catch (error) {
    console.warn(error);
    const response = {
      status: true,
      data: {}
    };
    return response;
  }
}

export async function viewSummaryFareSummary(
  currentBookingInState,
  feeCodes,
  passenger,
  activeStep = 0,
  bookingInRedux = null,
  story = null,
  selectedCurrency = DEFAULT_CURRENCY_CODE
) {
  // make it config it in some constant function :
  const feeCodesObj = {};
  let subtractAmount = 0;
  if (feeCodes != null && feeCodes?.values.length > 0) {
    feeCodes?.values.map((codeData, key) => {
      feeCodesObj[codeData.feeCode] = codeData;
    });
  }
  const passengerFareObject = {};
  const passengerFareOfJourney = currentBookingInState?.journeys;
  if (passengerFareOfJourney != null && passengerFareOfJourney.length > 0) {
    passengerFareOfJourney?.map((segmentDetails, key) => {
      segmentDetails?.segments?.map((singleSegmentDetails, key2) => {
        const tempPaxType = [];
        singleSegmentDetails?.fares?.map((passengerFare, key2) => {
          if (passengerFare?.passengerFares?.length > 0) {
            if (typeof passengerFareObject.tax === "undefined") {
              passengerFareObject.tax = [];
            }

            const hasSpecialFare = passengerFare?.passengerFares?.some(
              (fareInfo) =>
                fareInfo.passengerType === PASSENGER_TYPE.STUDENT ||
                fareInfo.passengerType === PASSENGER_TYPE.MEDICAL ||
                fareInfo.passengerType === PASSENGER_TYPE.ARMED_FORCE
            );

            passengerFare?.passengerFares.map((fareInfo, paxInd) => {
              if (typeof passengerFareObject[fareInfo.passengerType] === "undefined") {
                passengerFareObject[fareInfo.passengerType] = [];
              }
              if (!tempPaxType.includes(fareInfo.passengerType)) {
                tempPaxType.push(fareInfo.passengerType);
                fareInfo.serviceCharges.map((individualFare, index) => {
                  let count = passengerCount(passenger, fareInfo.passengerType, hasSpecialFare);

                  if (individualFare.type === "FarePrice") {
                    let tempAmount = 0;
                    let journeysFare = [];
                    if (
                      typeof passengerFareObject[fareInfo.passengerType].farePrice !== "undefined" &&
                      typeof passengerFareObject[fareInfo.passengerType].farePrice.amount !== "undefined"
                    ) {
                      tempAmount = passengerFareObject[fareInfo.passengerType].farePrice.amount;
                      count = count;
                    }
                    if (
                      typeof passengerFareObject[fareInfo.passengerType].farePrice !== "undefined" &&
                      typeof passengerFareObject[fareInfo.passengerType].farePrice.journeysFare !== "undefined"
                    ) {
                        journeysFare = passengerFareObject[fareInfo.passengerType].farePrice.journeysFare
                    }
                    const tempKey = `${segmentDetails?.designator?.origin}-${segmentDetails?.designator?.destination}`;

                    journeysFare.push({
                      [tempKey]: individualFare.amount  
                    })
                    passengerFareObject[fareInfo.passengerType].farePrice = {
                      amount: individualFare.amount + tempAmount,
                      journeysFare: journeysFare,
                      currencyCode: individualFare.currencyCode,
                      collectType: individualFare.collectType,
                      count,
                      type: individualFare.type
                    };
                  } else if (individualFare.type === "Discount" || individualFare.type === "PromotionDiscount") {
                    passengerFareObject.Discount =
                      passengerFareObject.Discount !== null && passengerFareObject.Discount !== undefined
                        ? passengerFareObject.Discount

                        : [];
                    const coupon =
                      individualFare.type === "PromotionDiscount"
                        ? currentBookingInState?.typeOfSale?.promotionCode
                        : "";
                    const discountPrevious = passengerFareObject.Discount[individualFare.code];
                    const discountUpdate = {
                      amount: discountPrevious
                        ? discountPrevious.amount + individualFare.amount * count
                        : individualFare.amount * count,

                      currencyCode: individualFare.currencyCode,
                      collectType: individualFare.collectType,
                      type: individualFare.type,
                      description: feeCodesObj[individualFare.code]?.name,
                      count: discountPrevious ? discountPrevious.count + count : count,
                      coupon
                    };
                    passengerFareObject.Discount[individualFare.code] = discountUpdate;
                  } else if (taxSkipCondition(activeStep, individualFare)) {
                    // add tax per persenger count :
                    if (typeof passengerFareObject.tax[individualFare.code] === "undefined") {
                      passengerFareObject.tax[individualFare.code] = [];
                      passengerFareObject.tax[individualFare.code] = {
                        amount: individualFare.amount * count,
                        currencyCode: individualFare.currencyCode,
                        collectType: individualFare.collectType,
                        description: feeCodesObj[individualFare.code]?.name,
                        count: passenger?.child + passenger?.adult + passenger?.seniorcitizen + passenger?.extraSeat,

                        type: individualFare.type
                      };
                    } else if (individualFare.type !== "IncludedTax") {
                      passengerFareObject.tax[individualFare.code].amount += individualFare.amount * count;
                    }
                  } else if (individualFare.type !== "IncludedTax") {
                    subtractAmount += individualFare.amount * count;
                  }
                });
              }
            });
          }
        });
      });
    });
  }

  let totalPassengers = null;
  if (currentBookingInState && currentBookingInState.passengers && currentBookingInState.extraSeatPassengers) {
    totalPassengers = [...currentBookingInState.passengers, ...currentBookingInState.extraSeatPassengers];
  }
  const adhos = await getAdhosPrice(totalPassengers, false, bookingInRedux, story);
  const penality = await getAdhosPrice(totalPassengers, true, null, story);
  const getinfat = getInfantfares(
    currentBookingInState?.passengers,
    currentBookingInState?.journeys?.length,
    selectedCurrency
  );
  const getComplementaryMeal = await getComplementryMeals(currentBookingInState?.passengerSegments, story);
  if (getinfat.status) {
    passengerFareObject.INF = [];
    passengerFareObject.INF.farePrice = getinfat;
  }
  if (getComplementaryMeal.status) {
    passengerFareObject.COMPLEMENTRY = {};
    passengerFareObject.COMPLEMENTRY = getComplementaryMeal.data;
  }
  passengerFareObject.ADHONS = adhos;
  passengerFareObject.PENALTIES = penality;

  if (currentBookingInState?.extraSeatPassengers && currentBookingInState?.extraSeatPassengers.length > 0) {
    passengerFareObject[PASSENGER_TYPE.EXTRA_SEAT] = {
      farePrice: {
        count: currentBookingInState?.extraSeatPassengers.length,
        amount: passengerFareObject?.EXST
        ?.farePrice?.amount,
        currencyCode: passengerFareObject?.EXST
        ?.farePrice?.currencyCode
      }
    };
  }
    
  if (currentBookingInState?.voucherDiscounts && currentBookingInState.voucherDiscounts.length > 0) {
    const totalVoucherDiscounts = currentBookingInState.voucherDiscounts
      .filter((bookingVoucher) => bookingInRedux?.listVoucherCodes?.some((stateVoucher) => stateVoucher.voucher === bookingVoucher.referenceNumber))
      .reduce((sum, {amount}) => sum + amount, 0)
    passengerFareObject.Vouchers = [{
      type: "redeemedVoucher",
      amount: totalVoucherDiscounts
    }]
  }

  passengerFareObject.subtractAmount = subtractAmount;
  return passengerFareObject;
}

export const viewSummaryPriceForFlightDetails = (
  passengerFare: any,
  feeCodes: any,
  passenger: any = null,
  brandFareIndex: any = 0,
  promoCode: string = ""
) => {
  const viewSummaryResponse = [];
  const taxData = [];
  try {
    const feeCodesObj = {};
    if (feeCodes != null && feeCodes?.values.length > 0) {
      feeCodes?.values.map((codeData, key) => {
        feeCodesObj[codeData.feeCode] = codeData;
      });
    }
    if (typeof passengerFare !== "undefined" && feeCodes) {
      passengerFare.map((paxFare, index) => {
        const passengerInfo = paxFare?.passengerFare[brandFareIndex[index]];

        const hasSpecialFare = Object.keys(passengerInfo)?.some(
          (fareInfo) =>
            fareInfo === PASSENGER_TYPE.STUDENT ||
            fareInfo === PASSENGER_TYPE.MEDICAL ||
            fareInfo === PASSENGER_TYPE.ARMED_FORCE
        );
        // adding all passenger amount :
        // let isTaxAddedFlag = false;
        Object.keys(passengerInfo).forEach((key) => {
          // key ==passengertype
          if (typeof viewSummaryResponse[key] === "undefined") {
            const tempAmount = passengerInfo[key]?.publishedFare;

            viewSummaryResponse[key] = {
              amount: tempAmount
            };
            if (typeof passengerInfo[key]?.count !== "undefined") {
              viewSummaryResponse[key].count = passengerInfo[key]?.count;
            }
          } else {
            const tempAmount = passengerInfo[key]?.publishedFare;

            viewSummaryResponse[key].amount += tempAmount;
          }
          let paxCount = passengerCount(passenger, key, hasSpecialFare);

          if (passenger != null) {
            if (key === PASSENGER_TYPE.ADULT && passenger.adult > 0) {
              viewSummaryResponse[key].count = passenger.adult;
              taxData.push({
                paxTypeTax: passengerInfo[key]?.tax,
                paxTypeCount: passenger.adult,
                paxTypeName: key
              });
            }
            if (key === PASSENGER_TYPE.STUDENT && passenger.adult > 0) {
              viewSummaryResponse[key].count = passenger.adult;
              taxData.push({
                paxTypeTax: passengerInfo[key]?.tax,
                paxTypeCount: passenger.adult,
                paxTypeName: key
              });
            }
            if (key === PASSENGER_TYPE.SENIOR_CITIZEN && passenger.seniorcitizen > 0) {
              viewSummaryResponse[key].count = passenger.seniorcitizen;
              taxData.push({
                paxTypeTax: passengerInfo[key]?.tax,
                paxTypeCount: viewSummaryResponse[key].count,
                paxTypeName: key
              });
            }
            if (key === PASSENGER_TYPE.CHILD && passenger.child > 0) {
              viewSummaryResponse[key].count = passenger.child;
              taxData.push({
                paxTypeTax: passengerInfo[key]?.tax,
                paxTypeCount: viewSummaryResponse[key].count,
                paxTypeName: key
              });
            }
            if (key === PASSENGER_TYPE.EXTRA_SEAT && passenger.extraSeat > 0) {
              viewSummaryResponse[key].count = passenger.extraSeat;
              taxData.push({
                paxTypeTax: passengerInfo[key]?.tax,
                paxTypeCount: viewSummaryResponse[key].count,
                paxTypeName: key
              });
            }
          }
        });
      });
      viewSummaryResponse.tax = [];
      taxData.map((tax, index) => {
        tax.paxTypeTax.map((currentTax, ind) => {
          if (
            currentTax.code !== CONVENIENCE_FEE_CODE &&
            currentTax.type !== "PromotionDiscount" &&
            currentTax.type !== "Discount" &&
            (currentTax.code != null || currentTax.detail != null)
          ) {
            let tempCode = currentTax.code; // tax type
            let tempDescription = feeCodesObj[tempCode]?.name;
            if (tempCode == null && currentTax.detail != null) {
              tempCode = "TaxSum";
              tempDescription = "Tax";
            }
            if (typeof viewSummaryResponse.tax[tempCode] === "undefined") {
              viewSummaryResponse.tax[tempCode] = {
                amount: currentTax.amount * tax.paxTypeCount,
                code: tempCode,
                foreignCurrencyCode: currentTax.foreignCurrencyCode,
                currencyCode: currentTax.currencyCode,
                description: tempDescription,
                count: passenger.total
              };
            } else {
              viewSummaryResponse.tax[tempCode].amount += currentTax.amount * tax.paxTypeCount;
            }
          } else if (currentTax.type === "PromotionDiscount" || currentTax.type === "Discount") {
            if (!viewSummaryResponse.Discount) {
              viewSummaryResponse.Discount = {};
            }
            if (viewSummaryResponse.Discount[currentTax.code]) {
              viewSummaryResponse.Discount[currentTax.code].amount += currentTax.amount * tax.paxTypeCount;
            } else {
              const tempPromocode = promoCode.toLowerCase();
              viewSummaryResponse.Discount[currentTax.code] = {
                amount: currentTax.amount * tax.paxTypeCount,
                code: currentTax.code,
                foreignCurrencyCode: currentTax.foreignCurrencyCode,
                currencyCode: currentTax.currencyCode,
                description: `Promo code applied ${tempPromocode}`,
                count: passenger.total,
                coupon: tempPromocode,
                type: currentTax.type
              };
            }
          }
        });
      });
    }
    //
  } catch (error) {
    console.warn("something went wrong");
    console.warn(error);
  }

  return viewSummaryResponse;
};

export function sumupPayment(currentBookingInState: Booking): number {
  try {
    const payments = currentBookingInState?.breakdown?.totalToCollect;
    return payments;
  } catch (error) {
    console.warn(error);
  }
  return 0;
}
